import React from "react";
import useObtenerSubsecciones from "../../../js/translations/useObtenerSubsecciones";
import PropTypes from "prop-types";
import { PlanCard } from "./plan-card";
/**
 * Componente de botón de compra
 */
export const PaymentButton = ({ enableBuyButton, price, discount, onClick }) => {
	const { textosSubSecciones: textos } = useObtenerSubsecciones("tienda_makemake");

	return (
		<div className="d-flex w-100 flex-column">
			<div className="w-100 d-flex justify-content-between align-items-center px-2">
				<PlanCard.PriceDescription price={price} discount={discount} />
				<button
					className="ml-2 buy-button px-3 focusable-red"
					disabled={!enableBuyButton}
					onClick={() => {
						onClick && onClick();
					}}
				>
					{textos?.barra_compra?.boton_comprar || "Comprar"}{" "}
				</button>
			</div>
			<div className="mt-3 px-3">
				<PlanCard.PricementDisclaimer />
			</div>
		</div>
	);
};

PaymentButton.propTypes = {
	/**
	 * Propiedad que indica si el botón de compra debe estar habilitado o no.
	 */
	enableBuyButton: PropTypes.bool,
	/**
	 * Objeto con la info del precio del producto en pesos colombianos y en dolares.
	 */
	price: PropTypes.shape({
		cop: PropTypes.string,
		usd: PropTypes.string,
	}),
	/**
	 * Objeto con la info del descuento del producto en pesos colombianos y en dolares.
	 */
	discount: PropTypes.shape({
		cop: PropTypes.shape({
			cantidad: PropTypes.string,
			precio: PropTypes.string,
		}),
		usd: PropTypes.shape({
			cantidad: PropTypes.string,
			precio: PropTypes.string,
		}),
	}),
	/**
	 * función callback que se ejecuta cuando se de click en el botón de compra.
	 */
	onClick: PropTypes.func,
};
